import React, {Component} from 'react';

//library
import Sortable from 'react-sortablejs';

//css
import styles from '../../static/css/componentStyleModules/memberGridList.module.scss';

import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent';

export default class MemberGridListComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            memberListMode:'order',
        };
    }

    gridButtunClicked = (memberData) => {
        if(this.props.currentWorkMode === 'displayMode'){
            //displayModeのときだけ、メンバーページに移動
            //propsに入っているものにメンバーのidを入れ込む
            this.props.gridButtonClickEvent(memberData);
        }
    }

    sortableChanged = (order) => {
        //sortablejsは、どうも与えられたdata-idをtoString()してしまうようなので、
        //objectをstring化してから、並べ替えたあとでobjectに戻している。

        const sortedList = order.map((value) => {
            return JSON.parse(value);
        })
        
        this.props.onSortChange(sortedList);
    }

    render(){

        const memberGrid = (member) => {

            const gridClassName = () => {                
                return (
                    this.props.currentWorkMode === 'displayMode'
                    ? styles['memberGridArea'] + ' thanksLogCard touchActiveDark'
                    : styles['memberGridArea'] + ' ' + styles['isOrderMode'] + ' thanksLogCard'
                )
            }
            return (
                <div className={gridClassName()} 
                key={member.id}
                data-id={JSON.stringify(member)}
                onClick={() => this.gridButtunClicked(member) }
                >
                  <div className={styles['faceIcon']}>
                    <FaceIconBaseComponent 
                    head={member.head} 
                    eyes={member.eyes} 
                    eyeblows={member.eyeblows} 
                    mouth={member.mouth} 
                    fillColor={member.color}/>
                  </div>
                  <h3>{member.name}</h3>
                </div>
            )
        }

        return(
            <div>
              {this.props.currentWorkMode === 'displayMode' 
              ? 
                <div className={styles['memberGridListArea']}>
                  {this.props.members.map(memberGrid)}
                </div>
              :
                <Sortable
                className={styles['memberGridListArea']}
                tag="div"
                options={{animation: 100}}
                onChange={(order) => this.sortableChanged(order)}
                >
                  {this.props.members.map(memberGrid)}
                </Sortable>
              }
            </div>
        )
    }
}